import React from 'react';
import { useCookies } from 'react-cookie';
import T from '../components/T';

const CookieLink = () => {
  const removeCookie = useCookies(['cookie-consent'])[2];
  return (
    <button
      type="button"
      className="button-link"
      onClick={() => {
        removeCookie('cookie-consent', {
          sameSite: 'strict',
          path: '/'
        });
        window.location.reload();
      }}
    >
      <T msg="cookieConsent.common.cookieConsentLink" />
    </button>
  );
};

export default CookieLink;



// WEBPACK FOOTER //
// ./app/Assets/js/features/cookieLink/index.js